import { DateType } from "../../data/types/index";
import { dateFormat } from "../../utilities/parseHelper";
import { dateFilter } from "../../filters/date.filter";
import i18n from "@/i18n";

/** Общая модель операции для выписок и истории операций */
export class DepositForecastItemModel {
  public Date: DateType = new Date();

  public Percents: number = 0;

  public Rest: number = 0;

  public InCome: number = 0;

  public Capitalization: boolean = false;

  constructor(src: any) {
    this.Date = dateFilter(src.Date, 'date') ?? dateFilter(new Date(), 'date');
    this.Percents = src.Percents ?? 0;
    this.InCome = src.Income ?? 0;
    this.Rest = src.Rest ?? 0;
    this.Capitalization = src.Capitalization ?? false;
  }
}
